import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Tecnica } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesTecnica, validationSchemaTecnica } from "./TecnicaCommon"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"
import { useTecnicaCreate } from "../../hooks/tecniche"
import TecnicaForm from "./TecnicaForm"

export default function TecnicaCreate() {
  const createTecnica = useTecnicaCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Tecniche", href: "/tecniche-immagini/tecniche-immagini" }, { label: "Nuova tecnica" }])

  const initialValues = useMemo(() => initialValuesTecnica(), [])
  const validationSchema = useMemo(() => validationSchemaTecnica(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova tecnica</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createTecnica.mutateAsync(values as Tecnica).then((tecnica) => {
                navigate(`/tecniche-immagini/tecniche-immagini`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TecnicaForm />
                </Container>
                <BottomFormFixed url="/tecniche-immagini/tecniche-immagini" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
